const NEW_COUNTERTOP_PRICES = [
    {
        id: 'SegmentPrice-21',
        type: 'SegmentPrice',
        product_code: 'COUNTERTOP',
        material_type: 'textured',
        width: 120,
        price: 800
    },
    {
        id: 'SegmentPrice-22',
        type: 'SegmentPrice',
        product_code: 'COUNTERTOP',
        material_type: 'textured',
        width: 144,
        price: 1000
    },
    {
        id: 'SegmentPrice-23',
        type: 'SegmentPrice',
        product_code: 'COUNTERTOP',
        material_type: 'textured',
        width: 168,
        price: 1200
    },
    {
        id: 'SegmentPrice-24',
        type: 'SegmentPrice',
        product_code: 'COUNTERTOP',
        material_type: 'textured',
        width: 192,
        price: 1400
    },
    {
        id: 'SegmentPrice-25',
        type: 'SegmentPrice',
        product_code: 'COUNTERTOP',
        material_type: 'economy',
        width: 120,
        price: 400
    },
    {
        id: 'SegmentPrice-26',
        type: 'SegmentPrice',
        product_code: 'COUNTERTOP',
        material_type: 'economy',
        width: 144,
        price: 500
    },
    {
        id: 'SegmentPrice-27',
        type: 'SegmentPrice',
        product_code: 'COUNTERTOP',
        material_type: 'economy',
        width: 168,
        price: 600
    },
    {
        id: 'SegmentPrice-28',
        type: 'SegmentPrice',
        product_code: 'COUNTERTOP',
        material_type: 'economy',
        width: 192,
        price: 700
    }
];
export const migrateToV2 = (state)=>{
    const existingKeys = new Set(state.filter((e)=>e.type === 'SegmentPrice').map((e)=>`${e.product_code}-${e.material_type}-${e.width}`));
    const toAdd = NEW_COUNTERTOP_PRICES.filter((p)=>!existingKeys.has(`${p.product_code}-${p.material_type}-${p.width}`));
    return [
        ...state,
        ...toAdd
    ];
};

//# sourceMappingURL=v2.js.map